import { useCallback, useEffect, useState } from "react";
import { fetchAllStatuses, buildStatusIndex } from "../services/statusApi";

// Shared hook used by blog / author pages to decorate author avatars with a
// "has active status" ring. Fetches the active-status list once and exposes a
// name-keyed index so callers don't each re-implement the grouping logic.
export default function useStatusIndex() {
  const [statusIndex, setStatusIndex] = useState({});
  const [loading, setLoading] = useState(true);
  const viewerId =
    typeof window !== "undefined" ? localStorage.getItem("userId") : null;

  const refresh = useCallback(async () => {
    try {
      const statuses = await fetchAllStatuses();
      setStatusIndex(buildStatusIndex(statuses, viewerId));
    } catch (err) {
      // Non-blocking: a failed status fetch must never break the host page,
      // it just means no rings are shown.
      console.error("status index fetch failed", err);
      setStatusIndex({});
    } finally {
      setLoading(false);
    }
  }, [viewerId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Look up a single author by name (case-insensitive). Returns null when the
  // author has no active status.
  const getStatusFor = useCallback(
    (name) => {
      if (!name) return null;
      return statusIndex[name.trim().toLowerCase()] || null;
    },
    [statusIndex]
  );

  return { statusIndex, getStatusFor, loading, refresh };
}
